export const responseBigQueryAccountMapping = '';